<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.orderStatus" allowClear placeholder="请选择订单状态">
                    <a-select-option v-for="(name, status) in orderStatusMap" :key="status" :value="status">
                      {{ name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="来源" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.sourceType" allowClear placeholder="请选择来源">
                    <a-select-option v-for="(name, type) in sourceTypeMap" :key="type" :value="type">
                      {{ name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="12" :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  <a-button style="margin-left: 8px" icon="sync" @click="handleSyncStatus">同步状态</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <section>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            @change="handleTableChange">
            <template slot="sourceType" slot-scope="text">
              <a-tag :color="sourceTypeColor[text] || ''">{{ sourceTypeMap[text] || text }}</a-tag>
            </template>
            <template slot="orderStatus" slot-scope="text, record">
              <a-tag :color="orderStatusColor[text] || ''">{{ record.orderStatusName || orderStatusMap[text] || text }}</a-tag>
            </template>
            <template slot="action" slot-scope="text, record">
              <template v-if="record.subType === '销售订单'">
                <a v-if="canRelate(record)" @click="handleRelate(record)">关联商品</a>
                <a @click="showQrCode(record)">出库码</a>
                <a-divider type="vertical" />
                <a @click="handlePrintShd(record)">送货单</a>
              </template>
            </template>
          </a-table>
        </section>
        <a-modal
          v-model="qrVisible"
          :title="qrTitle"
          :footer="null"
          :width="360"
          centered>
          <div class="qr-wrapper">
            <img v-if="qrBase64" :src="'data:image/png;base64,' + qrBase64" alt="出库二维码" class="qr-img" />
            <div class="qr-info">
              <p>出库单号：{{ qrData.xsckBillNo }}</p>
              <p>关联订单：{{ qrData.xsddBillNo }}</p>
              <p class="qr-tip">请客户在 H5「扫码入库」中扫描或输入此二维码内容</p>
            </div>
            <a-button type="primary" block icon="printer" style="margin-top: 12px" @click="printQrCode">打印二维码</a-button>
          </div>
        </a-modal>
        <order-center-print ref="orderPrint" />
        <a-modal
          :title="relateTitle"
          :visible="relateVisible"
          :confirmLoading="relateLoading"
          :maskClosable="false"
          width="760px"
          @ok="handleRelateOk"
          @cancel="relateVisible = false">
          <a-table
            size="small"
            bordered
            rowKey="itemId"
            :columns="relateColumns"
            :dataSource="relateItems"
            :pagination="false">
            <template slot="materialSelect" slot-scope="text, item">
              <a-select
                v-model="item.materialId"
                showSearch
                optionFilterProp="children"
                placeholder="请选择本方商品"
                style="width: 280px">
                <a-select-option v-for="material in materialOptions" :key="material.id" :value="material.id">
                  {{ material.materialName || material.name }}
                </a-select-option>
              </a-select>
            </template>
          </a-table>
          <div class="relate-tip">关联后本方商品将替换订单中的占位商品，并自动建立商品对应关系（后续同商品订单自动匹配）</div>
        </a-modal>
        <a-pagination
          style="margin-top: 16px; text-align: right"
          :current="ipagination.current"
          :pageSize="ipagination.pageSize"
          :total="ipagination.total"
          @change="paginationChange"
          @showSizeChange="paginationShowSizeChange"
        />
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getScanQrCode, syncOrderStatus, getRelateInfo, relateOrderMaterials, getMaterials } from '@/api/plugin/orderReceive'
import OrderCenterPrint from './OrderCenterPrint'

export default {
  name: 'OrderCenterList',
  mixins: [JeecgListMixin],
  components: { OrderCenterPrint },
  data() {
    return {
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 17,
        offset: 1
      },
      urlPath: '/plugin/order-receive/center',
      queryParam: {
        orderStatus: undefined,
        sourceType: undefined
      },
      qrVisible: false,
      qrLoading: false,
      qrTitle: '出库二维码',
      qrBase64: '',
      qrData: {},
      orderStatusMap: {
        '10': '发图中',
        '20': '已接单',
        '30': '备货中',
        '40': '已出库',
        '50': '配送中',
        '60': '已送达',
        '70': '已入库',
        '80': '已付款'
      },
      orderStatusColor: {
        '10': 'orange',
        '20': 'cyan',
        '30': 'blue',
        '40': 'purple',
        '50': 'geekblue',
        '60': 'green',
        '70': 'lime',
        '80': 'gold'
      },
      sourceTypeMap: {
        'qgd': '请购',
        'img': '发图',
        'manual': '手动'
      },
      sourceTypeColor: {
        'qgd': 'blue',
        'img': 'purple',
        'manual': 'orange'
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '单据号',
          dataIndex: 'billNo',
          width: 180
        },
        {
          title: '单据类型',
          dataIndex: 'subType',
          width: 100,
          align: 'center'
        },
        {
          title: '伙伴',
          dataIndex: 'partnerName',
          width: 180
        },
        {
          title: '来源',
          dataIndex: 'sourceType',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'sourceType' }
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'orderStatus' }
        },
        {
          title: '金额',
          dataIndex: 'totalPrice',
          width: 110,
          align: 'right'
        },
        {
          title: '时间',
          dataIndex: 'operTime',
          width: 160
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 140,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/plugin/order-receive/purchase-center'
      },
      relateTitle: '关联商品',
      relateVisible: false,
      relateLoading: false,
      relateHeadId: null,
      relateItems: [],
      materialOptions: [],
      relateColumns: [
        {
          title: '订单商品（占位）',
          dataIndex: 'materialName',
          width: 200
        },
        {
          title: '数量',
          dataIndex: 'operNumber',
          width: 110,
          align: 'right',
          customRender: function(text, record) {
            return text + (record.materialUnit || '')
          }
        },
        {
          title: '本方商品',
          dataIndex: 'materialId',
          scopedSlots: { customRender: 'materialSelect' }
        }
      ]
    }
  },
  methods: {
    /** 流转生成且未审核（已接单）的销售订单可关联商品 */
    canRelate(record) {
      return record.sourceType === 'qgd' && record.orderStatus === '20'
    },
    /** 关联商品：拉取未审核 XSDD 明细 + 本方商品下拉（当前占位商品并入选项保证回显） */
    handleRelate(record) {
      this.relateHeadId = record.headId
      this.relateTitle = '关联商品 - ' + record.billNo
      this.relateItems = []
      this.relateLoading = true
      this.relateVisible = true
      getRelateInfo(record.headId).then(res => {
        if (res.code === 200) {
          this.relateItems = res.data.items || []
          this.mergeMaterialOptions(this.relateItems.map(item => {
            return { id: item.materialId, name: item.materialName }
          }))
          this.loadMaterialOptions()
        } else {
          this.$message.warning(res.message || '查询失败')
          this.relateVisible = false
        }
      }).finally(() => {
        this.relateLoading = false
      })
    },
    /** 本方商品下拉（LIMIT 100，本地搜索过滤） */
    loadMaterialOptions() {
      getMaterials({}).then(res => {
        if (res.code === 200) {
          this.mergeMaterialOptions(res.data || [])
        }
      })
    },
    /** 按 id 去重合并选项，保证已选值始终可回显 */
    mergeMaterialOptions(rows) {
      const exists = {}
      for (const option of this.materialOptions) {
        exists[option.id] = true
      }
      const appended = []
      for (const row of rows) {
        if (row && row.id && !exists[row.id]) {
          exists[row.id] = true
          appended.push(row)
        }
      }
      if (appended.length > 0) {
        this.materialOptions = this.materialOptions.concat(appended)
      }
    },
    /** 确认关联：全部行选好本方商品后提交（映射+别名由后端沉淀） */
    handleRelateOk() {
      if (this.relateItems.length === 0) {
        this.$message.warning('该订单无有效明细')
        return
      }
      if (this.relateItems.some(item => !item.materialId)) {
        this.$message.warning('请为所有明细选择本方商品')
        return
      }
      this.relateLoading = true
      relateOrderMaterials({
        headId: this.relateHeadId,
        items: this.relateItems.map(item => {
          return { itemId: item.itemId, materialId: item.materialId }
        })
      }).then(res => {
        if (res.code === 200) {
          this.$message.success((res.data && res.data.message) || res.message || '关联成功')
          this.relateVisible = false
          this.loadData()
        } else {
          this.$message.warning(res.message || '关联失败')
        }
      }).finally(() => {
        this.relateLoading = false
      })
    },
    getQueryParams() {
      return {
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        orderStatus: this.queryParam.orderStatus,
        sourceType: this.queryParam.sourceType
      }
    },
    /** 出库码：获取 XSDD 关联出库单（XSCK）二维码并弹窗出示/打印 */
    showQrCode(record) {
      this.qrVisible = true
      this.qrLoading = true
      this.qrTitle = '出库二维码 - ' + record.billNo
      this.qrBase64 = ''
      this.qrData = {}
      getScanQrCode(record.headId).then(res => {
        if (res.success) {
          this.qrData = res.data || {}
          this.qrBase64 = this.qrData.qrBase64 || ''
        } else {
          this.$message.warning(res.message)
          this.qrVisible = false
        }
      }).finally(() => {
        this.qrLoading = false
      })
    },
    /** 打印二维码（打开新窗口仅打印二维码图片，保持简洁） */
    printQrCode() {
      if (!this.qrBase64) {
        return
      }
      const win = window.open('', '_blank')
      win.document.write('<html><head><title>出库二维码</title></head><body style="text-align:center">' +
        '<img src="data:image/png;base64,' + this.qrBase64 + '" style="width:300px;height:300px;" />' +
        '<p>出库单号：' + this.qrData.xsckBillNo + '</p>' +
        '<p>关联订单：' + this.qrData.xsddBillNo + '</p></body></html>')
      win.document.close()
      win.focus()
      win.print()
    },
    /** 打印送货单（SHD 模板：XSCK 出库内容 + 客户扫码收货二维码） */
    handlePrintShd(record) {
      this.$refs.orderPrint.show(record)
    },
    /** 手动触发状态同步（列表查询时也会自动惰性同步） */
    handleSyncStatus() {
      syncOrderStatus().then(res => {
        if (res.success) {
          this.$message.success('状态同步完成')
          this.loadData()
        } else {
          this.$message.warning(res.message)
        }
      })
    }
  }
}
</script>
<style scoped>
.table-page-search-wrapper { margin-bottom: 15px; }
.qr-wrapper { text-align: center; }
.qr-img { width: 260px; height: 260px; }
.qr-info p { margin: 6px 0; }
.qr-tip { color: #999; font-size: 12px; }
.relate-tip { color: #999; font-size: 12px; margin-top: 12px; }
</style>
